var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { lazy, Suspense, useState, useEffect, forwardRef } from 'react';
/**
 * Component that lazy-load an icon to display it.
 */
export var DynamicIcon = forwardRef(function (_a, ref) {
    var iconName = _a.iconName, props = __rest(_a, ["iconName"]);
    var _b = useState(import(
    /* webpackExclude: /\.d\.ts/ */
    "./generated/icons/".concat(iconName))), icon = _b[0], setIcon = _b[1];
    useEffect(function () { return setIcon(import(
    /* webpackExclude: /\.d\.ts/ */
    "./generated/icons/".concat(iconName))); }, [iconName]);
    var Icon = lazy(function () { return icon; });
    return (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
        React.createElement(Icon, __assign({ ref: ref }, props))));
});
